<template>
  <div>
    <div v-if="loading"
         class="loader">
      <div class="bar"></div>
    </div>
    <Header @load="loadPage"
            @search="searchData"
            @setFilters="setFilters">
    </Header>
    <div class="tickets-container">
      <TicketList @sortTickets="getTickets"
                  @setLoader="setLoader"
                  @pagination="getPagination">
      </TicketList>
      <TicketDetails></TicketDetails>
    </div>
    <InfoMessage></InfoMessage>
  </div>
</template>

<script>
import { assign, isEmpty, isEqual } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { paginable } from '../mixins';
import { bus } from '../utility';
import Header from './Header';
import TicketDetails from './TicketDetails';
import TicketList from './TicketList';
import InfoMessage from './InfoMessage';

export default {
  name: 'Tickets',
  components: {
    Header,
    InfoMessage,
    TicketDetails,
    TicketList,
  },
  mixins: [
    paginable,
  ],
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      search: null,
    };
  },
  computed: {
    ...mapGetters([
      'channel',
      'channels',
      'config',
      'exportType',
      'selectedFilters',
      'wheel',
      'platformTimezoneOffset',
      'translations',
      'ticketBets',
      'ticketFilters',
      'tickets',
      'token',
    ]),
    apiFilters() {
      return {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        format: this.exportType,
        wheelId: this.config.wheel.id,
        wheelAccountId: this.config.wheel.wheelAccountId,
        betChannelId: this.channel,
        paymentBetshop: this.selectedFilters.paymentBetshops,
        paymentOperator: this.selectedFilters.paymentOperators,
        paymentRetailRegister: this.selectedFilters.paymentCashRegisters,
        status: this.selectedFilters.statuses,
        players: this.selectedFilters.players,
        timezoneOffset: this.platformTimezoneOffset,
        token: this.token,
      };
    },
    dateFilters() {
      return {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        wheelAccountId: this.config.wheel.wheelAccountId,
        token: this.token,
      };
    },
  },
  watch: {
    apiFilters: {
      handler(newValue, oldValue) {
        if (this.token
          && !isEmpty(this.selectedFilters)
          && !isEqual(oldValue, newValue)) {
          this.loadPage();
        }
      },
      deep: true,
      immediate: true,
    },
    dateFilters: {
      handler() {
        if (this.token) {
          this.loadTicketFilters();
        }
      },
      deep: true,
      immediate: false,
    },
    channel(newValue, oldValue) {
      if (oldValue) {
        this.loadTicketFilters();
      }
    },
    ticketBets(update) {
      if (update) {
        this.loading = false;
      }
    },
  },
  methods: {
    ...mapActions([
      'loadTicketBets',
      'resetTicketsFilters',
      'setInfoMessage',
    ]),
    getTicketBets(ticketId) {
      this.loadTicketBets({
        wheelId: this.wheel.id,
        wheelAccountId: this.wheel.wheelAccountId,
        ticketId,
        locale: this.config.locale,
      });
    },
    loadPage() {
      if (this.wheel.id) {
        this.loading = true;
        this.apiParams.locale = this.config.locale;
        assign(this.apiParams, this.filters);
        this.$store.dispatch('loadTickets', this.apiParams).then((result) => {
          if (result.tickets.length) {
            this.setInfoMessage(null);
            this.getTicketBets();
          } else {
            this.setInfoMessage(this.translations.tableNoDataText);
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    loadTicketFilters() {
      if (this.wheel.id) {
        this.$store.dispatch('loadTicketFilters', {
          wheelId: this.wheel.id,
          wheelAccountId: this.wheel.wheelAccountId,
          dateFrom: this.apiFilters.dateFrom,
          dateTo: this.apiFilters.dateTo,
          betChannelId: this.channel,
          timezoneOffset: this.platformTimezoneOffset,
        });
      }
    },
    getTickets(value) {
      this.pagination.sortBy = value;
      this.pagination.descending = !this.pagination.descending;
      this.loadPage();
    },
    getPagination(value) {
      this.pagination.page = value.page;
      this.pagination.rowsPerPage = value.pageSize;
    },
    setFilters(value) {
      this.dateFrom = value.dateFrom;
      this.dateTo = value.dateTo;
    },
    setLoader() {
      this.loading = true;
    },
    searchData(value) {
      this.search = value;
      this.loadPage();
    },
  },
  mounted() {
    bus.$on('getPagination', (value) => {
      this.getPagination(value);
    });
  },
  beforeDestroy() {
    this.resetTicketsFilters();
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/general/_loader.scss";
.tickets-container {
  display: flex;
  padding: 10px;
  background-color: #ffff;
}

.v-content {
  min-height: 100vh;
}

.container {
  padding: 0;
}

@media only screen and (max-width: 1200px) {
  .tickets-container {
    flex-direction: column;
  }
  .tickets, .ticket-details {
    width: 100%;
  }
  .ticket-details {
    margin-top: 10px;
    padding: 0;
  }
}
</style>
